export default __webpack_public_path__ + "static/media/navbarLogo.767c794c.png";